<template>
  <div>
    <div
      class="text-subtitle1 text-bold q-px-sm"
      :class="this.$q.dark.mode === true ? 'text-grey-2' : 'text-primary'"
    >
      Divergence Signal
    </div>

    <div>
      <div
        v-if="
          this.$store.state.packages.packageStatus.current_package
            ?.expired_status &&
          !this.$store.state.packages.packageStatus?.extra_permissions?.includes(
            'DIVERGENCE_SIGNAL'
          )
        "
      >
        <MessageCard
          :displayMessage="'Your Divergence signals has expired. Please contact for extension'"
          :buttonText="'Subscribe Now'"
          :buttonRoute="'/payment'"
        />
      </div>
      <div v-else>
        <div class="q-pa-md">
          <q-radio
            keep-color
            dense
            color="teal"
            v-model="rsiOrMacd"
            val="rsi"
            :label="'RSI'"
          >
            <q-tooltip> Relative Strength Index </q-tooltip>
          </q-radio>
          <q-radio
            class="q-ml-md"
            keep-color
            dense
            color="teal"
            v-model="rsiOrMacd"
            val="macd"
            :label="'MACD'"
          >
            <q-tooltip> Moving Average Convergence/Divergence </q-tooltip>
          </q-radio>
        </div>
        <div class="q-px-sm q-gutter-sm row">
          <q-select
            v-model="buttonBuyOrSell"
            dense
            :hint="'Signal Type'"
            label="buy/sell"
            outlined
            :options="['buy', 'sell']"
            style="min-width: 10vw"
          ></q-select>
        </div>
        <!-- <div class="row q-pb-sm">
          <div class="justify-left q-gutter-sm">
            <q-radio
              v-model="timePeriod"
              val="hourly"
              label="Hourly"
              color="red"
              keep-color
            />
            <q-radio
              v-model="timePeriod"
              val="daily"
              label="Daily"
              color="cyan"
              keep-color
            />
            <q-radio
              v-model="timePeriod"
              val="weekly"
              label="Weekly"
              color="cyan"
              keep-color
            />
          </div>
          <q-space />
        </div> -->

        <div class="row q-pb-sm">
          <div class="justify-left q-gutter-sm">
            <q-radio
              v-model="divergenceOrHidden"
              val="divergence"
              label="Divergence"
              color="teal"
              keep-color
            />
            <q-radio
              v-model="divergenceOrHidden"
              val="hidden"
              label="Hidden Divergence"
              color="teal"
              keep-color
            />
          </div>
        </div>
        <q-card flat bordered>
          <q-tabs
            v-model="tab"
            dense
            inline-label
            outside-arrows
            mobile-arrows
            :class="
              this.$q.dark.mode === true
                ? 'bg-grey-10'
                : 'text-grey-9 bg-grey-4'
            "
            active-color="white"
            :active-bg-color="this.$q.dark.mode === true ? 'grey-9' : 'blue-4'"
            :indicator-color="this.$q.dark.mode === true ? 'grey-7' : 'blue-5'"
            align="justify"
            narrow-indicator
          >
            <q-tab name="divergence_alert" label="Divergence Alert" no-caps />
            <q-tab name="divergence_signal" label="Divergence Signal" no-caps />
          </q-tabs>

          <q-separator></q-separator>

          <q-tab-panels v-model="tab" animated>
            <q-tab-panel class="q-pa-none" name="divergence_alert">
              <ListCardTableView
                v-if="divergenceAlertData"
                :isMySignal="isMySignal"
                :isStockProfile="isStockProfile"
                :stockSymbol="stockSymbol"
                :tableTitle="'Divergence Alert'"
                :timePeriod="timePeriod"
                :buttonBuyOrSell="buttonBuyOrSell"
                :buyData="divergenceAlertData"
                :sellData="divergenceAlertSellData"
                :alertOrSignal="'alert'"
                @selectedSymbol="(eventSymbol) => (symbol = eventSymbol)"
                @EmitActiveInstance="
                  (eventData) => {
                    activeInstance = eventData;
                  }
                "
              />
            </q-tab-panel>
            <q-tab-panel class="q-pa-none" name="divergence_signal">
              <ListCardTableView
                :tableTitle="'Divergence Signal'"
                :isMySignal="isMySignal"
                :isStockProfile="isStockProfile"
                :stockSymbol="stockSymbol"
                :timePeriod="timePeriod"
                :buttonBuyOrSell="buttonBuyOrSell"
                :buyData="divergenceSignalData"
                :sellData="divergenceSignalSellData"
                :alertOrSignal="'signal'"
                @selectedSymbol="(eventSymbol) => (symbol = eventSymbol)"
                @EmitActiveInstance="
                  (eventData) => {
                    activeInstance = eventData;
                  }
                "
              />
            </q-tab-panel>
          </q-tab-panels>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watch, computed, onMounted } from "vue";
import { LocalStorage, useQuasar } from "quasar";
import { useStore } from "vuex";
import useData from "src/use/data";

import MessageCard from "src/components/MessageCard.vue";
import ListCardTableView from "src/components/TradingSignalsAndType/ListCardTableView.vue";

export default {
  emits: [
    "chartSymbol",
    "emitChartData",
    "emitPropsData",
    "buttonBuyOrSell",
    "indicators",
  ],
  props: {
    isMySignal: {
      type: Boolean,
      default: false,
    },
    isStockProfile: {
      type: Boolean,
      default: false,
    },
    stockSymbol: {
      type: String,
      default: null,
    },
  },
  components: {
    MessageCard,
    ListCardTableView,
  },
  setup(props, context) {
    const $q = useQuasar();
    const store = useStore();

    const {
      // Alert
      macdDivergencePriceAction,
      macdDivergenceSellPriceAction,
      //   Signal
      macdDivergencePriceActionSignal,
      macdDivergenceSellPriceActionSignal,

      // Alert
      rsiDivergenceAlertDailyWithPriceAction,
      rsiDivergenceSellAlertDailyWithPriceAction,
      //   Signal
      rsiDivergenceAlertDailyWithPriceActionSignal,
      rsiDivergenceSellAlertDailyWithPriceActionSignal,

      // Hidden Alert
      macdDivergencePriceActionHidden,
      macdDivergenceSellPriceActionHidden,
      // Hidden Signal
      macdDivergencePriceActionSignalHidden,
      macdDivergenceSellPriceActionSignalHidden,

      // Hidden Alert
      rsiDivergenceAlertDailyWithPriceActionHidden,
      rsiDivergenceSellAlertDailyWithPriceActionHidden,
      // Hidden Signal
      rsiDivergenceAlertDailyWithPriceActionSignalHidden,
      rsiDivergenceSellAlertDailyWithPriceActionSignalHidden,
    } = useData();

    let buttonBuyOrSell = ref("buy");
    let timePeriod = ref("daily");
    const activeInstance = ref([]);

    const tab = ref("divergence_alert");
    const symbol = ref("NEPSE");
    const rsiOrMacd = ref("rsi");
    const divergenceOrHidden = ref("divergence");

    const divergenceAlertData = ref([]);
    const divergenceAlertSellData = ref([]);

    const divergenceSignalData = ref([]);
    const divergenceSignalSellData = ref([]);

    const loadData = async (apiFunction, dataValue) => {
      dataValue.value = [];
      try {
        $q.loading.show({});
        const res = await apiFunction(365);
        dataValue.value = res.data;
      } catch (error) {
        console.error(error);
      } finally {
        $q.loading.hide();
      }
    };

    const updateDataBasedOnTimePeriod = (timePeriodValue) => {
      if (divergenceOrHidden.value === "divergence") {
        if (rsiOrMacd.value === "rsi") {
          if (timePeriodValue === "daily") {
            loadData(
              rsiDivergenceAlertDailyWithPriceAction,
              divergenceAlertData
            );
            loadData(
              rsiDivergenceSellAlertDailyWithPriceAction,
              divergenceAlertSellData
            );
            loadData(
              rsiDivergenceAlertDailyWithPriceActionSignal,
              divergenceSignalData
            );
            loadData(
              rsiDivergenceSellAlertDailyWithPriceActionSignal,
              divergenceSignalSellData
            );
          }
        } else if (rsiOrMacd.value === "macd") {
          if (timePeriodValue === "daily") {
            loadData(macdDivergencePriceAction, divergenceAlertData);
            loadData(macdDivergenceSellPriceAction, divergenceAlertSellData);
            loadData(macdDivergencePriceActionSignal, divergenceSignalData);
            loadData(
              macdDivergenceSellPriceActionSignal,
              divergenceSignalSellData
            );
          }
        }
      } else if (divergenceOrHidden.value === "hidden") {
        if (rsiOrMacd.value === "rsi") {
          if (timePeriodValue === "daily") {
            loadData(
              rsiDivergenceAlertDailyWithPriceActionHidden,
              divergenceAlertData
            );
            loadData(
              rsiDivergenceSellAlertDailyWithPriceActionHidden,
              divergenceAlertSellData
            );
            loadData(
              rsiDivergenceAlertDailyWithPriceActionSignalHidden,
              divergenceSignalData
            );
            loadData(
              rsiDivergenceSellAlertDailyWithPriceActionSignalHidden,
              divergenceSignalSellData
            );
          }
        } else if (rsiOrMacd.value === "macd") {
          if (timePeriodValue === "daily") {
            loadData(macdDivergencePriceActionHidden, divergenceAlertData);
            // loadData(
            //   macdDivergenceSellPriceActionHidden,
            //   divergenceAlertSellData
            // );
            divergenceAlertSellData.value = [];
            loadData(
              macdDivergencePriceActionSignalHidden,
              divergenceSignalData
            );
            // loadData(
            //   macdDivergenceSellPriceActionSignalHidden,
            //   divergenceSignalSellData
            // );
            divergenceSignalSellData.value = [];
          }
        }
      }
    };
    onMounted(() => {
      context.emit("indicators", [rsiOrMacd.value]);
    });
    watch(
      () => timePeriod.value,
      (newVal, oldVal) => {
        updateDataBasedOnTimePeriod(newVal);
      }
    );

    watch(
      () => rsiOrMacd.value,
      (newVal, oldVal) => {
        updateDataBasedOnTimePeriod(timePeriod.value);
        context.emit("indicators", [rsiOrMacd.value]);
      }
    );

    watch(
      () => divergenceOrHidden.value,
      (newVal, oldVal) => {
        updateDataBasedOnTimePeriod(timePeriod.value);
      }
    );

    watch(
      () => activeInstance.value,
      (newVal, oldVal) => {
        if (newVal != undefined) {
          context.emit("emitChartData", newVal);
          context.emit("chartSymbol", newVal.symbol);
          context.emit("buttonBuyOrSell", buttonBuyOrSell.value);
        }
      }
    );

    onMounted(() => {
      updateDataBasedOnTimePeriod(timePeriod.value);
    });

    return {
      activeInstance,
      timePeriod,
      buttonBuyOrSell,

      tab,
      symbol,
      divergenceAlertData,
      divergenceAlertSellData,
      divergenceSignalData,
      divergenceSignalSellData,
      rsiOrMacd,
      divergenceOrHidden,
    };
  },
};
</script>
